import React from 'react';
import cn from 'classnames';
import Image from 'next/image';

import Card from '../Card/Card';

import styles from './HighlightedTopItem.module.scss';
import Props from './HighlightedTopItem.props';

const HighlightedTopItem = ({
  thumbnail,
  title,
  excerpt,
  url,
  size = 'sm',
  className,
  position,
}: Props) => {
  return (
    <Card href={url} className={className}>
      <article className={cn(styles.HighlightedTopItem, styles[size])}>
        <div className={styles.Thumbnail}>
          {!!thumbnail && <Image src={thumbnail} alt="" quality={60} layout="fill" />}
        </div>
        <div className={styles.Content}>
          <h1 className={styles.Title}>
            {!!position && `${position}. `}
            {title}
          </h1>
          {!!excerpt && <p className={styles.Excerpt}>{excerpt}</p>}
        </div>
      </article>
    </Card>
  );
};

export default HighlightedTopItem;
